<script lang="ts">
    import type { ComponentProps } from "svelte";
    import ComboBox from "./ComboBox.svelte";
    import Err from './Error.svelte';

    const API_URL = '/api/losearch/searchbyname'

    interface Result {
        name: string,
        url: string
    }

    export let comboboxNoResultsLabel: ComponentProps<ComboBox>['noResultsLabel']
    export let label = "Loan Advisor Name"
    export let placeholder = "First or Last Name"
    export let errorMsg: string
    export let rootFolder: string

    let didError = false
    const search = async (input: string) => {
        const res = await fetch(`${API_URL}?rootFolder=${rootFolder}&term=${input}`)
        if (!res.ok) {
            didError = true
            throw res
        }
        return await res.json() as Result[]
    }

    let value: Result | undefined
    $: if (value) window.location.href = value.url
</script>

{#if didError}
    <Err>{@html errorMsg}</Err>
{:else}
    <ComboBox
        {label}
        {placeholder}
        {search}
        bind:value
        noResultsLabel={comboboxNoResultsLabel}
        itemToString={(i) => i.name}
    />
{/if}